import { BaseApiRequest } from "../../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { parseQueryParamsObject } from "@robe/core-utils";
import { DeleteAllReverseRelationsError, handleXcoreError } from "@robe/core-api/errors";

export const deleteAllReverseRelations = (contentId: number, core: XcoreCore, forceDelete?: boolean): BaseApiRequest<void> =>
  core
    .fetch(`/api/reverse-relation/${contentId}${forceDelete ? parseQueryParamsObject({ forceDelete }) : ""}`, { method: "DELETE" })
    .then((res, url) => {
      !res.ok && handleSaveContentError(url, res);
    });

const handleSaveContentError = handleXcoreError((...args) => new DeleteAllReverseRelationsError(...args));
